export default __webpack_public_path__ + "static/media/facing-tech-head.d88f4ef3.png";